import { WebFeatureFlags } from '@web/launchDarkly/flags';

export enum BuildType {
  default = 'default',
  embedded = 'embedded',
}

export interface DevOverrides {
  dashboardVisible: boolean;
  paginationSize?: number;
  featureFlags: Partial<WebFeatureFlags>;
}

export const BUILD_TYPES: readonly BuildType[] = Object.values(BuildType);
